// @flow
// idxgen-disable
import * as React from 'react';
import Raven from 'raven-js';

import 'styles/bootstrap.scss';
import 'styles/app.scss';

import store, { bootstrapDispatch } from 'store/configureStore';
import { main as theme } from 'themes';
import { initialDispatch as routerInitialDispatch } from 'modules/router';

import renderApp from './renderApp';
import bootstrap from './bootstrap';

// Raven JS
const SENTRY_DSN = process.env.REACT_APP_SENTRY_UI_DSN || '';
if (SENTRY_DSN.length > 0) {
  Raven.config(SENTRY_DSN, {
    ignoreUrls: [
      // Chrome extensions
      // @see https://gist.github.com/impressiver/5092952
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    sanitizeKeys: ['accessToken', 'refreshToken'],
    release: process.env.REACT_APP_RELEASE || 'development',
    environment: process.env.REACT_APP_SENTRY_ENV || 'none',
    serverName: window.location && window.location.hostname,
  }).install();
}

// Public object
window.SOFARM = {};

const rootNode = document.getElementById('app');

async function main() {
  await bootstrap();

  bootstrapDispatch();

  routerInitialDispatch();

  const { default: App } = await import('./App');

  if (rootNode) {
    renderApp(App, rootNode, { store, theme });
  }

  async function enableWhyDidYouUpdate(options) {
    if (process.env.NODE_ENV === 'production' || !rootNode) {
      return;
    }

    const { whyDidYouUpdate } = await import('why-did-you-update');
    whyDidYouUpdate(React, options);

    await renderApp(App, rootNode, { store, theme });
  }

  if (typeof window === 'object') {
    window.whyDidYouUpdate = enableWhyDidYouUpdate;
    window.renderApp = renderApp;
  }

  // Hot Module Replacement API
  if (module.hot && typeof module.hot.accept === 'function') {
    module.hot.accept('./App', async () => {
      const { default: NewApp } = await import('./App');
      if (rootNode) {
        // Re-render application
        renderApp(NewApp, rootNode, { store, theme });
      }
    });
  }
}

main();



// WEBPACK FOOTER //
// ./src/index.js